import { config } from "../config";
import { shortAddr } from "../lib/format";
import { Card, Notice, Stat } from "../components/ui";

export function Govern() {
  const gov = config.l2.contracts.governor;
  return (
    <>
      <div className="section-title">Governance</div>
      <Card title="GigaBrain governance" sub="1 vote per Brain whose stake crosses the GigaBrain threshold.">
        <p className="muted" style={{ fontSize: 14.5 }}>
          BasedGovernor is a standard OpenZeppelin Governor with a timelock. Voting power is snapshotted at proposal
          time, each Brain votes at most once, and passed proposals execute only after the timelock delay. Because it
          is a stock Governor, the richest UI for proposing, delegating, and voting is <strong>Tally</strong> — no
          bespoke interface needed.
        </p>
        <div className="grid cols-2" style={{ marginTop: 8 }}>
          <Stat label="Governor" value={<span className="mono" style={{ fontSize: 13 }}>{shortAddr(gov)}</span>} />
          <Stat label="Timelock" value={<span className="mono" style={{ fontSize: 13 }}>{shortAddr(config.l2.contracts.timelock)}</span>} />
        </div>
        <div style={{ marginTop: 18 }} className="row">
          <a className="btn" href={config.governanceUrl} target="_blank" rel="noreferrer">
            Open governance on Tally →
          </a>
        </div>
        <div style={{ marginTop: 16 }}>
          <Notice>
            Governance has no voting power until Brains are bridged to L2 — seed it by minting the reserved admin
            Brains (0–6) on L1 and bridging them over.
          </Notice>
        </div>
      </Card>
    </>
  );
}
